import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
import { Product } from '../products/models/products.models';
import { ProcessingService } from './processing.service';
import { Participant, ProcessingFormModel } from './models/processing.models';
import { BaseComponent } from '../_shared/base.component';
import { ProductsService } from '../products/products.service';
import { MessageService } from '../layout/message/message.service';

@Component({
	templateUrl: './processing.component.html',
	styleUrls: ['./processing.component.css', '../app.component.css'],
})
export class ProcessingComponent extends BaseComponent implements OnInit {
	public timeout = setTimeout;
	public api: string = environment.api;
	public sessionUniqueId: string;
	replaceState = false;
	// Notification properties
	msgs: Message[] = [];
	msgsSticky: Message[] = [];

	participants: Participant[] = [];
	newParticipant: Participant;
	product: Product;
	_customer = new ProcessingFormModel();
	errorMessage = '';
	addParticipant = false;
	public totalCost = 0;

	constructor(
		private processingService: ProcessingService,
		private productsService: ProductsService,
		private _activeRoute: ActivatedRoute,
		private _location: Location,
		router: Router,
		message: MessageService,
	) {
		super(router, message);
	}

	ngOnInit() {
		let productId: number;
		this._activeRoute.paramMap.subscribe(params => {
			if (params.has('uid') && params.has('id')) {
				this.sessionUniqueId = params.get('uid');
				productId = +params.get('id');
				localStorage.setItem('prodId', `${productId}`);
				this.getProduct(productId);
			} else if (params.has('id')) {
				productId = +params.get('id');
				localStorage.setItem('prodId', `${productId}`);
				this.processingService.generateUid().subscribe(
					rsp => {
						this.sessionUniqueId = rsp.Data;
						this.replaceState = true;
						this.getProduct(productId);
					},
					err => {
						this.showErrorMessage('Error', 'Failed Response');
					},
				);
			} else if (params.has('uid')) {
				this.sessionUniqueId = params.get('uid');
				productId = +localStorage.getItem('prodId');
				if (productId !== 0) {
					this.getProduct(productId);
				} else {
					this.readyForSession();
				}
			}
		});
	}

	getProduct(productId: number) {
		this.productsService.getProduct(productId).subscribe(
			rsp => {
				const { Data, Error } = rsp;
				if (Error) {
					this.showErrorMessage('Error', Error);
				} else {
					this.product = Data;
					this.showSuccessMessage('Product Loaded');
					if (this.replaceState) {
						this._location.replaceState(
							`/processing/participants/${this.sessionUniqueId}`,
							'',
							'Participant Processing',
						);
					}
				}
			},
			err => {
				this.showErrorMessage('Error', err.error);
			},
		);
		this.readyForSession();
	}
	readyForSession() {
		if (this.sessionUniqueId == null) {
			this.showErrorMessage('Error', 'Session not defined');
		} else {
			this.processingService.getParticipants(this.sessionUniqueId).subscribe(
				rsp => {
					const { Data, Error } = rsp;
					if (Error) {
						this.showInfoMessage('Transfer Hiccup', Error);
						this.sessionUniqueId = rsp.Data;
						this.timeout(() => {
							this._location.replaceState(
								`/processing/${this.product.Id}/${this.sessionUniqueId}`,
								'',
								'Participant Processing',
							);
							this.showSuccessMessage('Transferred', 'Success');
						}, 500);
					} else {
						this.participants = Data;
						const shiftParticipant = this.participants.length > 0 ? this.participants[0] : null;
						if (shiftParticipant != null) {
							if (this.product == null || shiftParticipant.ProductId !== this.product.Id) {
								this.showInfoMessage(null, 'Loading..');
								this.getProduct(shiftParticipant.ProductId);
							}
						} else {
							const prodId = localStorage.getItem('prodId');
							if (prodId == null && (this.product == null || this.product.Id == null)) {
								this.showErrorMessage('Session Expired', 'Please re-enter the tiny url address.');
								this.setErrorMessage('Session Expired. If issue continues, please contact support');
							}
						}
					}
				},
				err => {
					this.showErrorMessage('Error', err.error);
				},
			);
		}
	}

	setErrorMessage(msg: string) {
		this.errorMessage = msg;
	}
	showParticipantForm() {
		this.addParticipant = !this.addParticipant;
		this.newParticipant = new Participant(this.product.Id);
	}
	submitAddParticipant() {
		if (this.participants.length !== 0) {
			this.newParticipant.UniqueId = this.sessionUniqueId;
		}
		const validity = this.newParticipant.isValid();
		if (validity.HasError) {
			this.showErrorMessage('Invalid form', validity.Message);
			return;
		}
		this.processingService.saveParticipant(this.newParticipant).subscribe(
			rsp => {
				const { Error, Data } = rsp;
				if (Error) {
					this.showErrorMessage('Error', Error);
					return;
				}
				this.sessionUniqueId = Data.UniqueId;
				this.participants.push(Data);
				this.newParticipant = null;
				this.addParticipant = !this.addParticipant;
				this.showSuccessMessage('Success', 'Participant Added');
			},
			err => {
				this.showErrorMessage('Error', err.error);
				return;
			},
		);
	}

	cancelAdd() {
		this.addParticipant = !this.addParticipant;
	}

	deleteParticipant(id: number) {
		this.processingService.deleteParticipant(id).subscribe(
			rsp => {
				const { Error, Data } = rsp;
				if (Error) {
					this.showErrorMessage('Error', Error);
				} else if (Data === 'Success') {
					const index = this.participants.findIndex(x => x.Id === id);

					if (index > -1) {
						this.participants.splice(index, 1);
					} else {
						this.showErrorMessage('Error', 'Unable to delete participant');
					}
				}
			},
			err => {
				this.showErrorMessage('Error', err.error);
				return;
			},
		);
	}

	goToPayment() {
		const validity = this._customer.isValid();
		if (validity.HasError) {
			this.showErrorMessage('Invalid form', validity.Message);
			return;
		}
		if (this.participants.length === 0) {
			this.showInfoMessage('No Participants', 'Participants needed');
			return;
		}
		const nameModifier =
			this.participants.length > 1 ? ` (x${this.participants.length})` : '';
		const amtTotal = (this.product.Price * this.participants.length * 100).toFixed(0); // convert to pennies for Stripe
		this._router.navigate(
			[
				'/payments',
				this.product.Name + nameModifier,
				amtTotal,
				this.product.Id,
			],
			{
				queryParams: {
					name: this._customer.Name,
					email: this._customer.Email,
					phone: this._customer.Phone,
					puid: this.sessionUniqueId,
				},
			},
		);
	}
}
